<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 38.33 38.89"
    style="enable-background: new 0 0 38.33 38.89"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <polyline
        class="text-gray-300"
        points="13.24,18.08 13.24,1 37.33,1 37.33,37.89 1,37.89 1,25.28 10.79,15.68 20.58,25.28 20.58,37.89 	"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M13.49,32.69H7.72v-5.77h5.77V32.69z M9.72,30.69h1.77v-1.77H9.72V30.69z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M23.93,11.23h-5.77V5.46h5.77V11.23z M20.17,9.23h1.77V7.46h-1.77V9.23z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M33.06,11.23h-5.77V5.46h5.77V11.23z M29.29,9.23h1.77V7.46h-1.77V9.23z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M23.93,20.95h-5.77v-5.77h5.77V20.95z M20.17,18.95h1.77v-1.77h-1.77V18.95z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M33.06,20.95h-5.77v-5.77h5.77V20.95z M29.29,18.95h1.77v-1.77h-1.77V18.95z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M33.06,30.67h-5.77V24.9h5.77V30.67z M29.29,28.67h1.77V26.9h-1.77V28.67z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M38.33,38.89H0V24.86l10.79-10.58l1.45,1.42V0h26.09V38.89z M21.58,36.89h14.75V2H14.24v15.66l7.34,7.2V36.89z
		 M2,36.89h17.58V25.7l-8.79-8.62L2,25.7V36.89z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
